module.exports = __webpack_public_path__ + "static/img/tabbar_3.c58122ea.gif";